import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';

function Links(): JSX.Element {
  const { t } = useTranslation('component');

  const FooterLinks = [
    {
      Title: t('FooterLinkTitle.FAQ'),
      PathFR: 'https://www.familiprix.com/fr/pages/faq',
      PathEN: 'https://www.familiprix.com/en/pages/faq',
    },
    {
      Title: t('FooterLinkTitle.ContactUs'),
      PathFR: 'https://www.familiprix.com/fr/nous-joindre',
      PathEN: 'https://www.familiprix.com/en/contact-us',
    },
    { Title: t('FooterLinkTitle.FindAPharmacy'), PathFR: '', PathEN: '' }, //TBD
    {
      Title: t('FooterLinkTitle.Privacy'),
      PathFR: 'https://www.familiprix.com/fr/pages/politique-de-confidentialite',
      PathEN: 'https://www.familiprix.com/en/pages/privacy-policy',
    },
    {
      Title: t('FooterLinkTitle.OnlinePurchase'),
      PathFR: 'https://www.familiprix.com/fr/pages/politique-achat-en-ligne',
      PathEN: 'https://www.familiprix.com/en/pages/online-purchase-policy',
    },
    {
      Title: t('FooterLinkTitle.TermsAndConditions'),
      PathFR: 'https://www.familiprix.com/fr/pages/termes-et-conditions',
      PathEN: 'https://www.familiprix.com/en/pages/terms-and-conditions',
    },
  ];

  return (
    <Grid
      container
      justifyContent={{ xs: 'left', md: 'center' }}
      direction={{ xs: 'column', md: 'row' }}
      sx={{ mb: 5, alignItems: 'flex-start' }}>
      {FooterLinks.map((item, index) => (
        <Link
          key={item.Title}
          style={{
            textDecoration: 'none',
            marginRight: index == FooterLinks.length - 1 ? 0 : '2em',
            marginBottom: '6px',
          }}
          href={i18n.resolvedLanguage == 'fr' ? item.PathFR : item.PathEN}>
          {item.Title}
        </Link>
      ))}
    </Grid>
  );
}

function Copyright() {
  const { t } = useTranslation('component');

  return (
    <>
      <Typography align="center" fontSize={10} color="text.secondary">
        <Link style={{ cursor: 'default' }} href="https://Familiprix.com" color="inherit">
          {t('LegalTitle.Rights')} {new Date().getFullYear()}
        </Link>
      </Typography>
    </>
  );
}

function RegisterFooter(): JSX.Element {
  return (
    <Box component="footer" sx={{ p: 4, mt: 'auto' }}>
      <Links />
      <Container maxWidth="sm">
        <Copyright />
      </Container>
    </Box>
  );
}

export default RegisterFooter;
